import { render, staticRenderFns } from "./TaskComponent.vue?vue&type=template&id=ad7fc080&"
import script from "./TaskComponent.vue?vue&type=script&lang=js&"
export * from "./TaskComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports